/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
    return /^@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
    return /^(\+861[3-9]\d{9})$|(\+(852)[5|6|8|9]\d{7})$|(\+(853)\d{8})$/.test(s)
    // return /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
    return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}
